module.exports = __webpack_public_path__ + "img/reincarnated head of hieda.fd4e3a70.png";